import { render, staticRenderFns } from "./RegisterPartnerNation.vue?vue&type=template&id=2fc404da&scoped=true"
import script from "./RegisterPartnerNation.vue?vue&type=script&lang=js"
export * from "./RegisterPartnerNation.vue?vue&type=script&lang=js"
import style0 from "./RegisterPartnerNation.vue?vue&type=style&index=0&id=2fc404da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc404da",
  null
  
)

export default component.exports